import reportService from "@/services/ReportAdminService";
import M from "materialize-css";
import General from "@/assets/langpacks/General";
export default {
  name: "ReportAdmin",
  data: () => ({
    ReportData: [],

    UserID: 0,
    UserList: [],
    ServiceList: [],
    CarWashID: 0,
    CarWashList: [],
    PolicyNumber: "",
    CarNumber: "",
    StartSendDate: null,
    EndSendDate: null,
    StartAppoveDate: null,
    EndAppoveDate: null,
    CodeStatus: 0,
    ServiceID: 0,
    DateTimeOptions: null,
  }),
  components: {},
  mounted() {
    this.DateTimeOptions = {
      format: "yyyy-mm-dd",
      i18n: {
        months: General.Months.geo,
        monthsShort: General.Months.geoShort,
        weekdays: General.WeekDays.geo,
        weekdaysShort: General.WeekDays.geoShort,
        weekdaysAbbrev: General.WeekDays.geoAbbrev,
        cancel: "გაუქმება",
        done: "არჩევა",
      },
    };
    reportService.GetReportInitData().then((res) => {
      this.UserList = res.userList;
      this.InitMaterializeComponents();
      this.CarWashList = res.carWashList;
      this.ServiceList = res.limitList;
      this.GetData();
    });
  },

  methods: {
    InitMaterializeComponents() {
      this.$nextTick(function () {
        M.FormSelect.init(this.$refs.UserSelect, {});
        M.FormSelect.init(this.$refs.CarWashSelect, {});

        M.Datepicker.init(this.$refs.StartSendDate, this.DateTimeOptions);
        M.Datepicker.init(this.$refs.EndSendDate, this.DateTimeOptions);

        M.Datepicker.init(this.$refs.StartAppoveDate, this.DateTimeOptions);
        M.Datepicker.init(this.$refs.EndAppoveDate, this.DateTimeOptions);

        M.FormSelect.init(this.$refs.CodeStatusSelect, {});
        M.FormSelect.init(this.$refs.ServiceSelect, {});

        M.updateTextFields();
      });
    },
    ClearFilter() {
      this.PolicyNumber = null;
      this.CarNumber = null;
      this.UserID = 0;
      this.CarWashID = 0;
      this.StartSendDate = null;
      this.EndSendDate = null;
      this.StartAppoveDate = null;
      this.EndAppoveDate = null;
      this.CodeStatus = 0;
      this.ServiceID = 0;
      this.InitMaterializeComponents();
      this.GetData();
    },
    GetData() {
      reportService
        .GetReportData(
          this.PolicyNumber,
          this.CarNumber,
          this.UserID == 0 ? null : this.UserID,
          this.CarWashID == 0 ? null : this.CarWashID,
          this.ServiceID == 0 ? null : this.ServiceID,
          this.StartSendDate,
          this.EndSendDate,
          this.StartAppoveDate,
          this.EndAppoveDate,
          this.CodeStatus,
          false
        )
        .then((res) => {
          this.ReportData = res.data;
        });
    },
    DownloadData() {
      reportService.GetReportData(
        this.PolicyNumber,
        this.CarNumber,
        this.UserID == 0 ? null : this.UserID,
        this.CarWashID == 0 ? null : this.CarWashID,
        this.ServiceID == 0 ? null : this.ServiceID,
        this.StartSendDate,
        this.EndSendDate,
        this.StartAppoveDate,
        this.EndAppoveDate,
        this.CodeStatus,
        true
      );
    },
  },
};
